import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import NameField from '@/components/forms/new/formikFormFields/NameField';
import TriggerFieldToolTip from './TriggerFieldToolTip';
import { useTriggerForm } from '../useTriggerForm.js';
import { FORM_FIELD_PATHS } from '../triggerFormConstants.js';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';

const TriggerName = ({ darkMode, errors, touched }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { formData, updateFormData } = useTriggerForm();

    const handleChange = (e) => {
        updateFormData(FORM_FIELD_PATHS.NAME, e.target.value);
    };

    const hasError = !!errors?.name && touched?.name;

    return (
        <FormControl
            sx={{ margin: '0 !important', position: 'relative' }}
            isInvalid={hasError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel htmlFor="name" sx={formLabelStyling(darkMode)}>
                    Name <span style={{ color: '#e53e3e' }}>*</span>
                </FormLabel>
                <Box flex={1} maxWidth="400px">
                    <Field
                        component={NameField}
                        id="name"
                        name="name"
                        value={formData?.name || ''}
                        onChange={handleChange}
                        placeholder="Enter trigger name"
                        width="100%"
                        darkMode={darkMode}
                        isInvalid={hasError}
                        validate={(value) => {
                            if (!value) {
                                return 'Name is required';
                            }
                        }}
                    />
                </Box>
                <TriggerFieldToolTip
                    isVisible={isHovered}
                    label="Enter a descriptive name for this trigger"
                    ariaLabel="trigger-name-tip"
                />
            </Stack>
        </FormControl>
    );
};

export default TriggerName;
